import { pageSelectorGenerator } from '@test/pageSelectors';

export const GiftMethodsBadgeSelectors = pageSelectorGenerator('GiftMethodsBadge', ['PillText', 'UserNameText', 'LabelText']);
